import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { Category, CategoryNaturalKey } from '../../documents';
import { ActivityReportsBuildPart } from './activity-reports-build-part';
import { TrendAnalysisBuildPart } from './trend-analysis-build-part';
import { LabTestIdentity } from '../../sponsor/lab-results/lab-test';
import { TestResultsBuildPart } from './test-results-build-part';
import { KitInventoryBuildPart } from './kit-inventory-build-part';
import { SponsorStudySiteIdentity } from '../../sponsor/sites/sponsor-study-site-identity';
import {EQueryBuildPart} from './e-query-build-part';

export class StudyBuildPart extends BaseBuildPart {
    constructor(private readonly studyHelperParams: HelperParams,
                parent: BaseBuildPart,
                study: SponsorStudy) {
        super(studyHelperParams, parent, ['study', study.protocolId]);
    }

    public trendAnalysis(labTest?: LabTestIdentity): TrendAnalysisBuildPart {
        return new TrendAnalysisBuildPart(this.studyHelperParams, this, labTest);
    }

    public testResults(siteId?: number): TestResultsBuildPart {
        return new TestResultsBuildPart(this.studyHelperParams, this, siteId);
    }

    public sites(): BaseBuildPart {
        return new BaseBuildPart(this.studyHelperParams, this, ['sites']);
    }

    public sponsorCommunications(): BaseBuildPart {
        const categoryId: CategoryNaturalKey = 'sponsor-communications';
        return new BaseBuildPart(this.studyHelperParams, this, [categoryId]);
    }

    public subjects(subjectId?: string, tab?: string): BaseBuildPart {
        const routes = ['subjects'];

        if (subjectId) {
            routes.push(subjectId.toString());

            if (tab) {
                routes.push(tab);
            }
        }

        return new BaseBuildPart(this.studyHelperParams, this, routes);
    }

    public labReports(): BaseBuildPart {
        const labReportsRoutePath = ['lab-reports'];

        return new BaseBuildPart(this.studyHelperParams, this, labReportsRoutePath);
    }

    public kitInventory(siteId?: number): KitInventoryBuildPart {
        return new KitInventoryBuildPart(this.studyHelperParams, this, siteId); 
    }

    public tableau(): BaseBuildPart {
        const tableauRoutePath = ['tableau'];

        return new BaseBuildPart(this.studyHelperParams, this, tableauRoutePath); 
    }

    public studyDocuments(childCategory?: Category): BaseBuildPart {
        const studyDocumentsRoutePath = 'study-documents';
        if (!childCategory) {
            return new BaseBuildPart(this.studyHelperParams, this, [studyDocumentsRoutePath]);
        }
        return new BaseBuildPart(this.studyHelperParams, this, [studyDocumentsRoutePath, childCategory.categoryId]);
    }

    public siteDocuments(site?: SponsorStudySiteIdentity, childCategoryId?: CategoryNaturalKey): BaseBuildPart {
        const routePaths = ['site-documents'];
        if (site != null) {
            routePaths.push(site.siteId.toString());
        }
        if (childCategoryId != null) {
            routePaths.push(childCategoryId.toString());
        }

        return new BaseBuildPart(this.studyHelperParams, this, routePaths);
    }

    public eQueries(siteId?: number): EQueryBuildPart {
        return new EQueryBuildPart(this.studyHelperParams, this, siteId);
    }

    public resultAlerts(): BaseBuildPart {
        const resultAlertsPath = 'result-alerts';
        return new BaseBuildPart(this.studyHelperParams, this, [resultAlertsPath]);
    }

    public activityReports(): ActivityReportsBuildPart {
        return new ActivityReportsBuildPart(this.studyHelperParams, this);
    }
}
